import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { ModalFooter } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';

import { workTypesConstants } from '../servicePointConstants';
import { fieldsName } from './fieldConstants';

const MULTISELECT_FIELDS = [
  'supportedManufacturers',
  'supportedWorkTypes',
  'supportedFuelTypes',
  'supportedInsurances',
  'supportedProviders',
];

const getFieldConfig = (field, enums) => {
  const { name, value } = field;

  if (MULTISELECT_FIELDS.includes(name)) {
    const options =
      enums[name]?.map((item) => ({
        value: item.id,
        text:
          name === 'supportedWorkTypes'
            ? workTypesConstants[item.name]
            : item.name,
      })) || [];

    const matchEnum = (itemValue) =>
      enums[name]?.find((e) => e.id === itemValue)?.name;

    const defaultValue =
      value?.map((item) => ({
        value: item,
        text:
          name === 'supportedWorkTypes'
            ? workTypesConstants[matchEnum(item)]
            : matchEnum(item),
      })) || [];

    return { type: 'multiselect', options, defaultValue };
  }

  if (name === 'supportedBanks') {
    const options =
      enums[name]?.map((item) => ({
        value: item.id,
        text: item.name,
      })) || [];
    return { type: 'dropdown', options, defaultValue: value || '' };
  }

  return { type: 'text', options: [], defaultValue: value || '' };
};

const EditServicePointModalForm = ({
  field,
  enums,
  isSubmitting,
  onSubmit,
  onClose,
}) => {
  const { type, options, defaultValue } = getFieldConfig(field, enums);

  const methods = useForm({
    defaultValues: {
      [field.name]: defaultValue,
    },
    mode: 'onChange',
  });

  useEffect(() => {
    methods.reset({ [field.name]: defaultValue });
  }, [field]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <FieldV2
          name={field.name}
          label={fieldsName[field.name]}
          isRequired
          disabled={isSubmitting}
          control={methods.control}
          type={type}
          options={options}
          minify={type === 'multiselect' ? 1 : undefined}
          hasCheckboxes={type === 'multiselect'}
          keepScrollPosition={type === 'multiselect'}
        />
        <ModalFooter>
          <ButtonV2
            type="button"
            disabled={isSubmitting}
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </ButtonV2>
          <ButtonV2 type="submit" loading={isSubmitting}>
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default EditServicePointModalForm;
